module.exports = __webpack_public_path__ + "img/852-4b2cd7.png";